import { render, staticRenderFns } from "./TileRoof.vue?vue&type=template&id=4ee68594&scoped=true"
import script from "./TileRoof.vue?vue&type=script&lang=js"
export * from "./TileRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee68594",
  null
  
)

export default component.exports